import { useEffect } from "react";

const GtagEvents = () => {
  useEffect(() => {
    const handler = (e) => {
      const link = e.target.closest('a[href^="tel:"]');
      if (!link) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "phone_click",
        phone_number: link.getAttribute("href").replace("tel:", ""),
      });
      if (typeof window.gtag === "function") {
        window.gtag("event", "conversion", { send_to: "AW-18465206934/Z3eICMySi4AdEJbI8uRE" });
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);
  return null;
};

export default GtagEvents;
